module.exports = __webpack_public_path__ + "97f4d688d84ca7810140442e3a3f9e08.svg";